import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PanelT2Component } from './panel-t2.component';

@NgModule({
  declarations: [PanelT2Component],
  exports: [PanelT2Component],
  imports: [
    CommonModule,
  ]
})
export class PanelT2Module { }
